// Paths that render without app chrome: the login page, the token-gated
// invite/reset/review screens, and the consent page (`/connect`). Shared by the
// root layout (chrome suppression) and the global 401 handler (which must NOT
// bounce these to plain /login, or the invite/reset flows break for logged-out
// users).
//
// `/connect` is the one that needs a session: it is here for a focused screen
// about one decision, and so the root never asks `/me` for it. Its own guard
// (`requireConsentSession`) and the 401 handler send a person without a session
// to `/login?next=connect&request=<id>` (lib/oauth-consent.ts), never plain
// `/login`, so the sign-in returns them to the request.
export const PUBLIC_PATHS = ['/login', '/accept-invite', '/reset-password', '/creative-review', '/connect'];

export function isPublicPath(pathname: string): boolean {
  return PUBLIC_PATHS.includes(pathname);
}

/**
 * The public paths that still need a session: chromeless, but every 401 there sends the person
 * to sign in (main.tsx), and an identity change in another tab reloads them through their guard
 * (cache/data-revision-coordinator.ts), so the page never shows one person and decides as
 * another.
 */
export const SESSION_PUBLIC_PATHS = ['/connect'];

export function isSessionPublicPath(pathname: string): boolean {
  return SESSION_PUBLIC_PATHS.includes(pathname);
}
